export default __webpack_public_path__ + "static/media/Padron_2000Closed.607e93a1.jpg";